import React from 'react'
import Topbar from '../Layout/Topbar'
import Navbar from '../Common/Navbar'


const Header = () => {
  return (
    <header className="fixed top-0 left-0 w-full mb-5 z-50 bg-white border-b border-gray-200">
        {/* Topbar */}
        <Topbar />
        {/* Navbar */}
        <Navbar />
        {/* Cart Drawer */}
        {/* <CartDrawer /> */}
    </header>
  )
}

export default Header;
